import React from "react";
import "./termsAndConditions.scss";
const TermsAndConditions = () => {
  return (
    <>
      <div id="terms-and-conditions-wrapper">
        <section style={{ padding: "2rem 0" }}>
          <div className="container">
            <div className="the_content_single">
              <h2>Terms and Conditions</h2>
              <h4>Effective Date: May 25, 2023</h4>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Molestias explicabo vitae alias doloremque eos. Dolore dolorem
                illum non saepe praesentium, harum soluta recusandae nisi minus
                id, nesciunt similique dolores totam.
              </p>
              <h2>use of the website:</h2>
              <h3>1.1 Eligibility:</h3>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Molestias explicabo vitae alias doloremque eos. Dolore dolorem
                illum non saepe praesentium, harum soluta recusandae nisi minus
                id, nesciunt similique dolores totam.
              </p>
              <h3>1.2 License:</h3>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Molestias explicabo vitae alias doloremque eos. Dolore dolorem
                illum non saepe praesentium, harum soluta recusandae nisi minus
                id, nesciunt similique dolores totam.
              </p>
              <h3>1.3 User Responsibilities:</h3>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Molestias explicabo vitae alias doloremque eos. Dolore dolorem
                illum non saepe praesentium, harum soluta recusandae nisi minus
                id, nesciunt similique dolores totam.
              </p>
              <h4>Compliance:</h4>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Molestias explicabo vitae alias doloremque eos. Dolore dolorem
                illum non saepe praesentium, harum soluta recusandae nisi minus
                id, nesciunt similique dolores totam.
              </p>
              <h4>Service Quality:</h4>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Molestias explicabo vitae alias doloremque eos. Dolore dolorem
                illum non saepe praesentium, harum soluta recusandae nisi minus
                id, nesciunt similique dolores totam.
              </p>
              <h4>Customer Support:</h4>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Molestias explicabo vitae alias doloremque eos. Dolore dolorem
                illum non saepe praesentium, harum soluta recusandae nisi minus
                id, nesciunt similique dolores totam.
              </p>
              <h2>Intellectual Property:</h2>
              <h3>2.1 Ownership:</h3>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Molestias explicabo vitae alias doloremque eos. Dolore dolorem
                illum non saepe praesentium, harum soluta recusandae nisi minus
                id, nesciunt similique dolores totam.
              </p>
              <h3>2.2 Trademarks:</h3>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Molestias explicabo vitae alias doloremque eos. Dolore dolorem
                illum non saepe praesentium, harum soluta recusandae nisi minus
                id, nesciunt similique dolores totam.
              </p>
              <h2>Third-Party Content and Links:</h2>
              <h3>3.1 Third-Party Content:</h3>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Molestias explicabo vitae alias doloremque eos. Dolore dolorem
                illum non saepe praesentium, harum soluta recusandae nisi minus
                id, nesciunt similique dolores totam.
              </p>
              <h3>3.2 Third-Party Links:</h3>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Molestias explicabo vitae alias doloremque eos. Dolore dolorem
                illum non saepe praesentium, harum soluta recusandae nisi minus
                id, nesciunt similique dolores totam.
              </p>
              <h2>Limitation of Liability:</h2>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Molestias explicabo vitae alias doloremque eos. Dolore dolorem
                illum non saepe praesentium, harum soluta recusandae nisi minus
                id, nesciunt similique dolores totam.
              </p>
              <h2>Indemnification:</h2>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Molestias explicabo vitae alias doloremque eos. Dolore dolorem
                illum non saepe praesentium, harum soluta recusandae nisi minus
                id, nesciunt similique dolores totam.
              </p>
              <h2>Termination:</h2>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Molestias explicabo vitae alias doloremque eos. Dolore dolorem
                illum non saepe praesentium, harum soluta recusandae nisi minus
                id, nesciunt similique dolores totam.
              </p>
              <h2>Governing Law and Jurisdiction:</h2>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Molestias explicabo vitae alias doloremque eos. Dolore dolorem
                illum non saepe praesentium, harum soluta recusandae nisi minus
                id, nesciunt similique dolores totam.
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default TermsAndConditions;
